import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import CSVReports from './CSVReports';
import PDFReports from './PDFReports';
import '../superadmin/DistrictsList.css';

const Reports = () => {
  const location = useLocation();

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Reports</h2>
        <p style={{ fontSize: '0.9em', color: '#666', marginTop: '0.5rem' }}>
          Generate and export reports for your district's forms and student data.
        </p>
      </div>

      {/* Sub-navigation for Reports */}
      <div style={{ marginBottom: '2rem', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>
        <nav style={{ display: 'flex', gap: '1rem' }}>
          <Link
            to="/district-admin/reports/csv"
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: location.pathname.includes('/csv') ? '#007bff' : '#f8f9fa',
              color: location.pathname.includes('/csv') ? 'white' : '#007bff',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #007bff'
            }}
          >
            CSV Reports
          </Link>
          <Link
            to="/district-admin/reports/pdf"
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: location.pathname.includes('/pdf') ? '#007bff' : '#f8f9fa',
              color: location.pathname.includes('/pdf') ? 'white' : '#007bff',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #007bff'
            }}
          >
            PDF Reports
          </Link>
        </nav>
      </div>

      <Routes>
        <Route path="/csv" element={<CSVReports />} />
        <Route path="/pdf" element={<PDFReports />} />
        <Route path="/" element={
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h3>Select a Report Type</h3>
            <p>Choose CSV or PDF reports from the tabs above to get started.</p>
          </div>
        } />
      </Routes>
    </div>
  );
};

export default Reports;


